import { Box } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import HistoryActiveIcon from '../../../assets/images/icons/menu/history-active-icon.png';
import HistoryIcon from '../../../assets/images/icons/menu/history-icon.png';
import MemberActiveIcon from '../../../assets/images/icons/menu/member-active-icon.png';
import MemberIcon from '../../../assets/images/icons/menu/member-icon.png';
import PrivilegeActiveIcon from '../../../assets/images/icons/menu/privilege-active-icon.png';
import PrivilegeIcon from '../../../assets/images/icons/menu/privilege-icon.png';
import RewardActiveIcon from '../../../assets/images/icons/menu/reward-active-icon.png';
import RewardIcon from '../../../assets/images/icons/menu/reward-icon.png';

const menus = [
  {
    id: 1,
    name: 'Reward',
    href: '/reward',
    icon: RewardIcon,
    iconActive: RewardActiveIcon,
  },
  {
    id: 2,
    name: 'Privilege',
    href: '/privilege',
    icon: PrivilegeIcon,
    iconActive: PrivilegeActiveIcon,
  },
  {
    id: 3,
    name: 'History',
    href: '/history',
    icon: HistoryIcon,
    iconActive: HistoryActiveIcon,
  },
  {
    id: 4,
    name: `Me &\nMy Coupon`,
    href: '/member',
    icon: MemberIcon,
    iconActive: MemberActiveIcon,
  },
];

const MenuBar = () => {
  const { pathname } = useLocation();

  // const isClosingEvent = useEventStore(state => state.isClosingEvent)
  // const newMenu = isClosingEvent ? menus.slice(1) : menus;

  return (
    <Box
      sx={{
        width: '100%',
        height: '70px',
        position: 'fixed',
        bottom: '0',
        left: '0',
        backgroundColor: '#E1000C',
      }}
    >
      <Box
        maxWidth={'md'}
        mx={'auto'}
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          width: '100%',
          height: '100%',
        }}
      >
        {menus.map((m) => (
          <Box key={m.id} sx={{ width: '100%' }}>
            <Link
              to={m.href}
              style={{
                fontSize: '1rem',
                lineHeight: 0.75,
                color: 'white',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textDecoration: 'none',
              }}
            >
              <Box
                component={'img'}
                src={pathname === m.href || pathname.includes(m.href) ? m.iconActive : m.icon}
                alt={m.name}
                sx={{ width: '40px', height: '40px' }}
              />
              <Box component={'span'} sx={{ whiteSpace: 'pre-wrap', textAlign: 'center' }}>
                {m.name}
              </Box>
            </Link>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default MenuBar;
